export const COMSCORE_TRACKER_NAME = 'COMSCORE';
export const FACEBOOK_TRACKER_NAME = 'fbq';
export const GOOGLE_TRACKER_NAME = 'buzzfeed_ga';
export const NIELSEN_TRACKER_NAME = 'NOLCMB';
export const NIELSEN_TRACKER_STATE_NAME = 'NOLCMB_STATE';
export const OUTBRAIN_TRACKER_NAME = 'obApi';
export const PERMUTIVE_TRACKER_NAME = 'permutive';
export const PINTEREST_TRACKER_NAME = 'pintrk';
export const QUANTCAST_TRACKER_NAME = '_qevents';
export const SAILTHRU_TRACKER_NAME = 'Sailthru';
export const SNAPCHAT_TRACKER_NAME = 'snaptr';
export const TIKTOK_TRACKER_NAME = 'ttq';
